import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import { OffboardingEmployeeListComponent } from "../offboarding-employee-list/offboarding-employee-list.component";
import { Router, ActivatedRoute } from "@angular/router";
import {
  DateAdapter,
  MatDialog,
  MatTableDataSource,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material";
import { Toast, ToastrService } from "ngx-toastr";
import { UserService } from "../../shared/service/user.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { OffboardingCheckListResultClass } from "../../shared/models/OffboardingCheckListResultClass";
import { debug, isNullOrUndefined } from "util";
import { HRStatus, Offboarding } from "../../shared/models/Offboarding";
import { UpdateOffboardingResgnStatus } from "../../shared/models/UpdateOffboardingResgnStatus";
import { OffbaordingFeedbackTypeClass } from "../../shared/models/OffbaordingFeedbackTypeClass";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { EmpFBAnswers } from "../../shared/models/EmpFBAnswers";
import { EmpFbQuestions } from "../../shared/models/EmpFbQuestions";
import { MatRadioModule } from "@angular/material";
import { MatRadioChange } from "@angular/material";
import { DepartmentsService } from "../../departments.service";
import * as _moment from "moment";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { Employee } from "../../../Models/Employee";
import { MapOperator } from "rxjs/internal/operators/map";
import { Moment } from "moment";
import { DatePipe } from "@angular/common";
import { AppConfig } from "../../app.config";
import { HREmployeeDetails } from "../../shared/models/hremployeecommunicationdetails.model";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { ExitReason } from "../../../Models/ExitReason";
import { ExitReasonDetails } from "../../shared/models/ExitReasonDetails";
import { File_Types } from "../../shared/UploadFileTypes";
import { FileUploadService } from "../../shared/service/fileUpload.service";

const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-offboarding-queue",
  templateUrl: "./offboarding-queue.component.html",

  styleUrls: ["./offboarding-queue.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class OffboardingQueueComponent implements OnInit {
  @Output("parentFun") parentFun: EventEmitter<any> = new EventEmitter();
  @Input() employeeCode: number;
  @Input() offboardingId: number;
  @Input() type: string;
  @Input() isApprove: any;
  @Input() isCancel: any;
  @Input() isReject: any;
  @Input() isSave: any;
  @Input() tab: string;
  exitReason: ExitReason;
  offboardingForm: FormGroup;
  exitcategorylist: any[];
  reasonlist: any[];
  offboarding: Offboarding;
  todayDate: Date;
  exitReasons: any;
  fileoffboarding: any;
  error: string;
  exception = false;
  empCode: any;
  datePipe: DatePipe;
  offboardinglist: ExitReasonDetails[];
  reasonDetail: string;
  exitreasonid: number;
  empName: any;
  LoginEmpCode: any;
  employeeList: any[] = [];
  emplist: Offboarding[] = [];
  filteredList: any;
  resultArray: Offboarding[] = [];
  EmployeeCode: any;
  employeeId: any;
  MAX_SIZE: number = 1048576;
  minResigDate: Moment;
  minDate: Date;
  exitcategoryComments: string;
  peopleManagerEmail: string;
  peopleManagerName: string;
  employeeDisplayList: any[] = [];
  removeSaveOnInitiate: boolean;
  removeInitiateExit: boolean;
  displayInitiateExit: boolean;
  empDOJ: Date;
  resminCode: any;
  loader: boolean;
  hideOffboardingEmpList: any[] = [];
  onlyIndianEmployees: any[] = [];
  filteredEmpList: any[] = [];
  updateOffboardingResgnStatus: UpdateOffboardingResgnStatus;
  LWDRequired = false;
  IsManagerApprReject: any;
  selectedPO: any = null;
  finalShowCC: string[];
  selectedMasterIds: any = null;
  poList: any;
  selected: any = null;
  disable = false;
  empList: any;
  ccEntries: any[] = [];
  originalCClength;
  permission: any;
  MaxItems: number;
    ProjectMgr: any;

  constructor(
    private empsvc: EmployeeService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private config: AppConfig,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public cdr: ChangeDetectorRef,
    private file_Svc: FileUploadService,
    private _userService: UserService,
  ) {
    this.todayDate = new Date();
    this.empDOJ = new Date();
    //this.minResigDate. = new Date().;
    this.fileoffboarding = new Offboarding();
    const currentYear = moment().year();
    this.minResigDate = moment([currentYear - 1, 8, 1]);
    this.updateOffboardingResgnStatus = new UpdateOffboardingResgnStatus();
  }

  ngOnInit() {
    this.loader = true;
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Name === "Offboarding-list"
    );
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
    });
    
    this.offboarding = new Offboarding();
    this.LoginEmpCode = this.userService.getEmpCode();
    if (!isNullOrUndefined(this.empCode) && this.type != "Manager") {
      this.offboardingForm = this.formBuilder.group({
        ResignationDate: [moment(), [Validators.required]],
        LastWorkingDay: [moment(), Validators.required],
        ExitID: ["", [Validators.required]],
        ReasonID: ["", [Validators.required]],
        Comments: ["", [Validators.required]],
        employeeId: ["", [Validators.required]],
        ExitEmailFile: ["", [Validators.required]],
        ReasonComments: ["", [Validators.required]],
      });
      this.getActiveProjectManagers();
      this.getOffboardingdetailsbyCode();
      this.getExitReasons();
      this.getexitreasonbyid();
      this.getEmployeeList();
      this.getPeopleManagerCodeandMail();
      this.getDOJEmployeebyCode();
    } else if (
      !isNullOrUndefined(this.employeeCode) &&
      this.type == "Manager"
    ) {
        this.empCode = this.employeeCode;
      this.offboardingForm = this.formBuilder.group({
        ResignationDate: [moment(), [Validators.required]],
        LastWorkingDay: [
          moment(),
          this.tab == "MyApprovals" ? Validators.required : "",
        ],
        ExitID: [""],
        ReasonID: ["", [Validators.required]],
        Comments: [""],
        IndicativeLWD: [""],
        employeeId: [""],
        ExitEmailFile: [""],
        CC:[""],
        ReasonComments: [""],
        ManagerComments: [""],
        ProjectManagers:[""]
      });
      this.getProjectManagers();
      this.getOffboardingDetailsById();
      this.getExitReasons();
      this.getexitreasonbyid();
      this.getEmployeeList();
      this.getPeopleManagerCodeandMail();
      this.getDOJEmployeebyCode();
    } else {
      this.getEmployeeList();
      this.getOffboardingdetails();
      this.getPeopleManagerCodeandMail();

      const nonWhitespaceRegExp: RegExp = new RegExp("\\S");

      this.offboardingForm = this.formBuilder.group({
        ResignationDate: [moment(), [Validators.required]],
        LastWorkingDay: [moment(), Validators.required],
        ExitID: ["", [Validators.required]],
        ReasonID: ["", [Validators.required]],
        Comments: ["", [Validators.required]],
        employeeId: ["", [Validators.required]],
        ExitEmailFile: ["", [Validators.required]],
        ReasonComments: ["", [Validators.required]],
      });

      this.getexitreasonbyid();
      this.getExitReasons();
    }
    setTimeout(() => {
      this.loader = false;
    }, 1500);
  }

  get f() {
    return this.offboardingForm.controls;
  }

  getProjectManagers() {
    this.empsvc
      .getActiveProjectManagersByCode(this.empCode)
      .subscribe((data: any) => {
        this.poList = data;
        if (this.poList) {
          this.selectedPO = this.poList.split(",");
          this.selected = this.poList != null && this.poList.split(",").length > 1 ? this.poList.split(",").join(", ") : this.selectedPO;
        }
      });
  }

  getActiveProjectManagers() {
    this.empsvc
      .getActiveProjectManagersByCode(this.empCode)
      .subscribe((data: any) => {
        this.poList = data;
        if (this.poList) {
          this.selectedPO = this.poList.split(",");
          this.selected = this.poList != null && this.poList.split(",").length > 1 ? this.poList.split(",").join(", ") : this.selectedPO;
        }
        this.getOffboardingdetailsbyCode();
      });
  }

  getDOJ(event) {
    var id = event.option.value.split("-");
    this.resminCode = id[0];
    this.getDOJEmployeebyCode();
  }
  getDOJEmployeebyCode() {
    if (!isNullOrUndefined(this.empCode)) {
      this.empsvc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.empDOJ = data.DOJ;
      });
    } else {
      this.empsvc
        .getBasicEmployeeById(this.resminCode)
        .subscribe((data: any) => {
          this.empDOJ = data.DOJ;
        });
    }
  }
  autoGrowTextZone(e) {
    e.target.style.height = "0px";
    e.target.style.height = e.target.scrollHeight + 10 + "px";
  }
  getexitreasonbyid() {
    this.empsvc.GetExitReasonByID(1).subscribe();
  }
  getExitReasons() {
    this.empsvc.GetExitReasons().subscribe((data: any) => {
      this.exitcategorylist = data;
    });
  }

  getOffboardingDetailsById() {
    this.empsvc
      .getOffboardingDetailsById(this.offboardingId)
      .subscribe((data: any) => {
        const finalData = data;
        this.offboarding = finalData;
        this.ProjectMgr = finalData.ProjectManagers;
        this.disable = this.offboarding.finalStatus == HRStatus.Submit ? false : true;
        if (this.offboarding.Status != "Saved")
          this.removeSaveOnInitiate = true;
        else this.removeSaveOnInitiate = false;
        if (
          this.offboarding.Status == "Saved" ||
          this.offboarding.Status == "Initiated"
        ) {
          this.removeInitiateExit = false;
          this.displayInitiateExit = true;
        } else {
          this.removeInitiateExit = true;
          this.displayInitiateExit = false;
        }
        if (this.offboarding.ResignationDate != null) {
          this.setLastWorkingDate(this.offboarding.ResignationDate);
        }
        //if (this.offboarding.CC) {
        //  const arrayPO = Array.isArray(this.selectedPO)
        //    ? this.selectedPO
        //    : this.selectedPO;
        //  if (arrayPO != null && arrayPO.length > 0) {
        //    this.finalShowCC = this.offboarding.CC.split(",").filter(
        //      (item) => !arrayPO.includes(item)
        //    );
        //    this.selectedMasterIds = this.finalShowCC;
        //  } else {
        //    this.selectedMasterIds = this.offboarding.CC;
        //  }
        //}
         if (this.offboarding.CC) {
          const ccEntries = this.offboarding.CC.split(",").map(entry => {
            const [recDisplayName, empCode] = entry.split(" - ");
            return { recDisplayName, empCode: Number(empCode) };
          });
          this.selectedMasterIds = ccEntries.map(entry => entry.empCode);
        }

        this.originalCClength = Number(JSON.parse(JSON.stringify(this.selectedMasterIds != "" && this.selectedMasterIds != null ? this.selectedMasterIds.length : 0)))
        this.reasons(this.offboarding.ExitID);
        this.exitreasonid = this.offboarding.ReasonID;
      });
  }

  getMaxItemsLength() {
    this.MaxItems = this.originalCClength + 2;
    return this.originalCClength + 2;
  }

  getOffboardingdetailsbyCode() {
    this.empsvc.getOffboardingDetails(this.empCode).subscribe((data: any) => {
      const finalData = data;
      this.offboarding = finalData;
      if (this.offboarding.Status != "Saved") this.removeSaveOnInitiate = true;
      else this.removeSaveOnInitiate = false;
      if (
        this.offboarding.Status == "Saved" ||
        this.offboarding.Status == "Initiated"
      ) {
        this.removeInitiateExit = false;
        this.displayInitiateExit = true;
      } else {
        this.removeInitiateExit = true;
        this.displayInitiateExit = false;
      }
      if (this.offboarding.ResignationDate != null) {
        this.setLastWorkingDate(this.offboarding.ResignationDate);
      }
      if (this.offboarding.CC) {
        const ccEntries = this.offboarding.CC.split(",").map(entry => {
          const [recDisplayName, empCode] = entry.split(" - ");
          return { recDisplayName, empCode: Number(empCode) };
        });
        this.selectedMasterIds = ccEntries.map(entry => entry.empCode);
      }
      this.originalCClength = Number(JSON.parse(JSON.stringify(this.selectedMasterIds != "" || this.selectedMasterIds != null ? this.selectedMasterIds && this.selectedMasterIds.length : 0)))
      this.reasons(this.offboarding.ExitID);
      this.exitreasonid = this.offboarding.ReasonID;
    });
  }

  getOffboardingdetails() {
    this.empsvc.getAllOffboardingDetails().subscribe(
      (data: Offboarding[]) => {
        this.emplist = data;
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getEmployeeList() {
    this.empsvc.getAllActiveEmployees().subscribe(
      (data: any[]) => {
        const tempList = [];
        this.empList = data;
        //const pmCode = this.offboarding.To ? this.offboarding.To.split(' - ')[1] : null;
        //const poCodes = this.offboarding && this.offboarding.ProjectManagers ? this.offboarding.ProjectManagers.split(' - ')[1] : null;
        //const excludedCodes = [pmCode,poCodes, String(this.empCode)].filter(code => code);
        const pmCode = this.offboarding.To ? this.offboarding.To.split(' - ')[1] : null;
        const poCodes = this.offboarding.ProjectManagers && this.offboarding.ProjectManagers ? this.offboarding.ProjectManagers && this.offboarding.ProjectManagers.split(',').map(code => code && code.split(' - ')[1]).filter(Boolean) : this.selected && this.selected.split(',').map(code => code && code.split(' - ')[1]) || [];
        const excludedCodes = [pmCode, ...poCodes].filter(code => code);

        this.empList.forEach((el) => {
          if (!excludedCodes.includes(String(el.EmpCode))) {
            let item = el;
            item.recDisplayName = el.FirstName + " - " + el.EmpCode;
            item.recEmpCode = el.EmpCode;
            tempList.push(item);
          }
        });
        this.filteredEmpList = tempList;
        if (!isNullOrUndefined(this.empCode))
          this.empName = data.filter(
            (x) => x.EmpCode == this.empCode
          )[0].FirstName;
        else this.employeeList = data;

        this.hideOffboardingEmpList = this.employeeList;
        for (var i = 0; i < this.emplist.length; i++) {
          for (var j = 0; j < this.employeeList.length; j++) {
            if (this.employeeList[j].EmpCode == this.emplist[i].EmpCode) {
              this.hideOffboardingEmpList.splice(j, 1);
            }
          }
        }

        for (var k = 0; k < this.hideOffboardingEmpList.length; k++) {
          if (
            this.hideOffboardingEmpList[k].LocationName == "Hyderabad" ||
            this.hideOffboardingEmpList[k].LocationName == "Bengaluru"
          ) {
            this.onlyIndianEmployees.push(this.hideOffboardingEmpList[k]);
          }
        }

        this.employeeList = this.onlyIndianEmployees;
        this.filteredList = this.employeeList;
      },
      (error) => (this.error = error)
    );
  }

  shouldHideClearIcon(item: any): boolean {
    var cc = null;
    if (this.offboarding.CC != null) {
      //const arrayPO = Array.isArray(this.selectedPO)
      //  ? this.selectedPO
      //  : this.selectedPO;
      //if (arrayPO != null && arrayPO.length > 0) {
      //  this.finalShowCC = this.offboarding.CC.split(",").filter(
      //    (item) => !arrayPO.includes(item)
      //  );
      //  cc = this.finalShowCC.map((entry) => {
      //    const empcode = entry;
      //    return empcode;
      //  });
      //}
      //else {
        const ccEntries = this.offboarding.CC.split(",");
        cc = ccEntries.map((entry) => {
          const empcode = entry;
          return empcode;
        });
     // }
    }
    return cc != null ? cc.includes(item.recDisplayName):null;
  }

  removeSelectedId(item: any): void {
    this.selectedMasterIds = this.selectedMasterIds.filter(id => id !== item.EmpCode);
    let originalSelectedCC: number[] = [];

    if (this.offboarding.CC) {
      //const arrayPO = Array.isArray(this.selectedPO) ? this.selectedPO : [];

      //if (arrayPO.length > 0) {
      //  this.finalShowCC = this.offboarding.CC.split(",").filter(
      //    (item) => !arrayPO.includes(item)
      //  );
      //} else {
        this.finalShowCC = this.offboarding.CC.split(",");


      originalSelectedCC = this.finalShowCC.map((entry) => {
        const [, EmpCode] = entry.split(" - ");
        return Number(EmpCode);
      });
    }

    const originalLength = originalSelectedCC.length;
    const selectedLength = this.selectedMasterIds.length;

    if ((originalLength > 0 && selectedLength - originalLength >= 2) ||
      (originalLength === 0 && selectedLength >= 2) ||
      this.offboarding.finalStatus !== HRStatus.Submit) {
      this.disable = true;
    } else {
      this.disable = false;
    }
    this.cdr.detectChanges();
  }

  //onChangeCCValues(selectedIds: string[]) {
  //  let originalSelectedCC: number[] = [];

  //  if (this.offboarding.CC) {
  //    //const arrayPO = Array.isArray(this.selectedPO) ? this.selectedPO : [];

  //    //if (arrayPO.length > 0) {
  //    //  this.finalShowCC = this.offboarding.CC.split(",").filter(
  //    //    (item) => !arrayPO.includes(item)
  //    //  );
  //    //} else {
  //      this.finalShowCC = this.offboarding.CC.split(",");
  //    //}

  //    originalSelectedCC = this.finalShowCC.map((entry) => {
  //      const [, EmpCode] = entry.split(" - ");
  //      return Number(EmpCode);
  //    });
  //  }

  //  const originalLength = originalSelectedCC.length;
  //  const selectedLength = selectedIds.length;

  //  if ((originalLength > 0 && selectedLength - originalLength >= 2) ||
  //    (originalLength === 0 && selectedLength >= 2) ||
  //    this.offboarding.finalStatus !== HRStatus.Submit) {
  //    this.disable = true;
  //  } else {
  //    this.disable = false;
  //  }

  //  this.cdr.detectChanges();
  //}

  onChangeCCValues(selectedIds: string[]) {
    if (!this.offboarding.CC) {
      this.offboarding.CC = ''; 
    }
    this.finalShowCC = this.offboarding.CC.split(",");

    let originalSelectedCC: number[] = this.finalShowCC.map(entry => {
      const [, EmpCode] = entry.split(" - ");
      return Number(EmpCode);
    });

    const originalLength = originalSelectedCC.length;
    const selectedLength = selectedIds.length;

    this.disable = (originalLength > 0 && selectedLength - originalLength >= 2) ||
      (originalLength === 0 && selectedLength >= 2) ||
      this.offboarding.finalStatus !== HRStatus.Submit;

    this.cdr.detectChanges();
  }


  getDisplayName(id: number): string | undefined {
    return this.selectedMasterIds
      .map(id => {
        const employee = this.filteredEmpList.find(emp => emp.recEmpCode === id);
        return employee ? employee.recDisplayName : null;
      })
      .filter(name => name)
      .join(', ');
  }

  getsavedreasons(reasonid: number) {
    this.empsvc.getReasons().subscribe((data: any) => {
      var category = data.filter((x) => x.ReasonID == reasonid);
      return category[0].ExitReasonDetails;
    });
  }
  reasons(event: any) {
    if (event == 1) {
      this.empsvc.GetExitReasonByID(event).subscribe((data: any) => {
        this.reasonlist = data;
      });
    } else if (event == 2) {
      this.empsvc.GetExitReasonByID(event).subscribe((data: any) => {
        this.reasonlist = data;
      });
    } else {
      this.empsvc.getReasons().subscribe((data: any) => {
        this.reasonlist = data;
      });
    }
  }
  //Cancel() {
  //  this.router.navigateByUrl(
  //    `/Offboardinglist/tabIndex/${
  //      Number(sessionStorage.getItem("tabIndex")) || 0
  //    }`
  //  );
  //}
  Reset() {
    this.offboardingForm.reset();
  }
  doFilter() {
    if (!isNullOrUndefined(this.EmployeeCode)) {
      this.filteredList = this.filter(this.employeeList);
    }
  }

  filter(values) {
    return values.filter((value) =>
      value.FirstName.toLowerCase().includes(this.EmployeeCode.toLowerCase())
    );
  }

  // SaveOffboardingDetails() {
  //   window.scrollTo(0, 0);
  //   this.loader = true;

  //   if (
  //     isNullOrUndefined(this.empCode) &&
  //     this.offboardingForm.controls.employeeId.invalid
  //   ) {
  //     this.loader = false;
  //     this.toastr.warning("Employee Code is required.");
  //     return;
  //   }
  //   if (this.offboarding.ExitID == 3) {
  //     this.offboarding.ReasonID = 9;
  //   }
  //   this.datePipe = new DatePipe("en-US");
  //   if (!isNullOrUndefined(this.offboarding.ResignationDate)) {
  //     this.offboarding.ResignationDate = new Date(
  //       this.datePipe.transform(
  //         this.offboarding.ResignationDate,
  //         this.config.dateFormat()
  //       )
  //     );
  //   }
  //   if (!isNullOrUndefined(this.offboarding.LastWorkingDay)) {
  //     this.offboarding.LastWorkingDay = new Date(
  //       this.datePipe.transform(
  //         this.offboarding.LastWorkingDay,
  //         this.config.dateFormat()
  //       )
  //     );
  //   }

  //   if (this.offboarding.ResignationDate > this.offboarding.LastWorkingDay) {
  //     this.loader = false;
  //     this.toastr.warning(
  //       "LWD should  be greater than or equal to Resignation Date."
  //     );
  //     return;
  //   }
  //   this.offboarding.CreatedBy = this.LoginEmpCode;
  //   this.offboarding.ModifiedBy = this.LoginEmpCode;
  //   this.offboarding.Status = "Saved";
  //   this.offboarding.InitiateLWDMail = true;
  //   if (isNullOrUndefined(this.empCode)) {
  //     var id = this.EmployeeCode.split("-");
  //     this.offboarding.EmpCode = id[0];
  //   }
  //   if (isNullOrUndefined(this.empCode)) {
  //     var check = this.EmployeeCode.split("-");
  //     var mailCheckinList = this.employeeList.filter(
  //       (x) => x.EmpCode == check[0]
  //     );
  //     if (mailCheckinList.length == 0) {
  //       this.loader = false;
  //       this.toastr.warning("Please select an employee from dropdown.");
  //       this.EmployeeCode = "";
  //       return;
  //     }
  //   }
  //   var now = new Date();
  //   var mm = now.getMonth() + 1;
  //   var currentYear;
  //   var year;
  //   currentYear = now.getFullYear();
  //   year = now.getFullYear().toString().substr(2, 2);
  //   if (3 < mm) {
  //     currentYear = now.getFullYear();
  //     year = now.getFullYear().toString().substr(2, 2);
  //   } else {
  //     currentYear = now.getFullYear() - 1;
  //     year = (now.getFullYear() - 1).toString().substr(2, 2);
  //   }
  //   this.offboarding.FinancialYear = currentYear + "-" + (parseInt(year) + 1);
  //   this.offboarding.NewITData = true;
  //   this.empsvc.SaveOffboardingDetails(this.offboarding).subscribe(
  //     (data: Offboarding) => {
  //       this.toastr.success("Form Saved Successfully.");
  //       this.loader = false;

  //       this.router.navigateByUrl("/Offboardinglist");
  //     },
  //     (error) => (this.error = error)
  //   );
  // }
  setLastWorkingDate(resignationDate: Date) {
    const resignDate = new Date(resignationDate);
    const fromYear = resignDate.getFullYear();
    const fromMonth = resignDate.getMonth();
    const fromDate = resignDate.getDate();
    this.minDate = new Date(fromYear, fromMonth, fromDate);
  }
  handleFile(event) {
    if (event.target.files == undefined) {
      this.offboarding.ExitEmailFile = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.offboarding.ExitEmailFile = this.file_Svc.readAndUploadFile(files);
      } else {
        this.toastr.warning(
          " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
        );
        //  Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
        //this.FinanceForm.controls.CancelledChequeFile.reset();
      }
    }
  }
  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }
  getPeopleManagerCodeandMail() {
    this.empsvc
      .getPeopleManagerCodeandMail(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.peopleManagerEmail = data.ManagerEmail;
        this.peopleManagerName = data.ManagerName;
      });
  }
  // InitiateExit() {
  //   window.scrollTo(0, 0);
  //   this.loader = true;
  //   if (
  //     isNullOrUndefined(this.empCode) &&
  //     this.offboardingForm.controls.employeeId.invalid
  //   ) {
  //     this.loader = false;

  //     this.toastr.warning("Employee Code is required.");
  //     return;
  //   }
  //   this.datePipe = new DatePipe("en-US");
  //   if (!isNullOrUndefined(this.offboarding.ResignationDate)) {
  //     this.offboarding.ResignationDate = new Date(
  //       this.datePipe.transform(
  //         this.offboarding.ResignationDate,
  //         this.config.dateFormat()
  //       )
  //     );
  //   }
  //   if (!isNullOrUndefined(this.offboarding.LastWorkingDay)) {
  //     this.offboarding.LastWorkingDay = new Date(
  //       this.datePipe.transform(
  //         this.offboarding.LastWorkingDay,
  //         this.config.dateFormat()
  //       )
  //     );
  //   }

  //   if (this.offboarding.ResignationDate > this.offboarding.LastWorkingDay) {
  //     this.loader = false;
  //     this.toastr.warning(
  //       "LWD should  be greater than or equal to Resignation Date."
  //     );
  //     return;
  //   }
  //   if (this.offboarding.ExitEmailFileName == null) {
  //     if (this.offboardingForm.controls.ExitEmailFile.invalid) {
  //       this.loader = false;
  //       this.toastr.warning("Attachment required.");
  //       return;
  //     }
  //   }
  //   if (this.offboarding.ResignationDate == null) {
  //     this.loader = false;
  //     this.toastr.warning("Resignation Date required.");
  //     return;
  //   }
  //   if (this.offboarding.ExitID == null) {
  //     this.loader = false;
  //     this.toastr.warning("Exit type required.");
  //     return;
  //   }
  //   if (this.offboarding.ReasonID == null) {
  //     this.loader = false;
  //     this.toastr.warning("Reason required.");
  //     return;
  //   }
  //   this.datePipe = new DatePipe("en-US");
  //   this.offboarding.ResignationDate = new Date(
  //     this.datePipe.transform(
  //       this.offboarding.ResignationDate,
  //       this.config.dateFormat()
  //     )
  //   );
  //   this.offboarding.LastWorkingDay = new Date(
  //     this.datePipe.transform(
  //       this.offboarding.LastWorkingDay,
  //       this.config.dateFormat()
  //     )
  //   );
  //   //  this.offboarding.CreatedBy = this.LoginEmpCode;
  //   this.offboarding.ModifiedBy = this.LoginEmpCode;

  //   this.offboarding.PeopleManagerEmail = this.peopleManagerEmail;
  //   this.offboarding.PeopleManagerName = this.peopleManagerName;
  //   this.offboarding.Status = "Initiated";

  //   //this.offboarding.EmpCode = this.EmployeeCode;
  //   if (isNullOrUndefined(this.empCode)) {
  //     var id = this.EmployeeCode.split("-");
  //     this.offboarding.EmpCode = id[0];
  //   }
  //   var now = new Date();
  //   var mm = now.getMonth() + 1;
  //   var currentYear;
  //   var year;
  //   currentYear = now.getFullYear();
  //   year = now.getFullYear().toString().substr(2, 2);
  //   if (3 < mm) {
  //     currentYear = now.getFullYear();
  //     year = now.getFullYear().toString().substr(2, 2);
  //   } else {
  //     currentYear = now.getFullYear() - 1;
  //     year = (now.getFullYear() - 1).toString().substr(2, 2);
  //   }
  //   this.offboarding.FinancialYear = currentYear + "-" + (parseInt(year) + 1);
  //   this.offboarding.NewITData = true;
  //   this.offboarding.clickingInitaiteExit = true;
  //   this.empsvc.InitiateOffboardingDetails(this.offboarding).subscribe(
  //     (data: Offboarding) => {
  //       this.toastr.success("Exit Initiated Successfully.");
  //       this.loader = false;
  //       this.router.navigateByUrl("/Offboardinglist");
  //     },
  //     (error) => (this.error = error)
  //   );
  // }

  confrimModal(val) {
    if (this.selectedMasterIds) {
      const ccEntries = this.selectedMasterIds
        .map((empCode) => {
          const employee = this.empList.find((emp) => emp.EmpCode === empCode);
          return employee ? employee.recDisplayName : null;
        })
        .filter((entry) => entry !== null);

      this.offboarding.CC = ccEntries.join(",");
    } else {
      this.offboarding.CC = null;
    }

    this.LWDRequired = val == "Reject" ? false : true;
    var LWD = this.offboardingForm.get("LastWorkingDay");
    if (
      this.displayInitiateExit ||
      (this.type == "Manager" && this.LWDRequired && this.tab == "MyApprovals")
    ) {
      LWD.setValidators([Validators.required]);
    } else {
      LWD.clearValidators();
    }
    LWD.updateValueAndValidity();
    if (this.offboardingForm.valid) {
      this.loader = true;
      var msg;
      if (val == "Approve") msg = "Approver comments";
      else if (val == "Reject") msg = "Rejection Comments";
      else msg = `Are you sure to ${val}?`;
      var deleteType =
        val == "Approve" || val == "Reject" ? "Manager" : "Submit";
      const dialogData = new ConfirmDialogModel(
        val == "Quick Approve" ? "Approve" : val,
        msg,
        deleteType
      );
      this.datePipe = new DatePipe("en-US");
      if (val != "Quick Approve") {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "800px",
          data: dialogData,
        });
        dialogRef.afterClosed().subscribe(
          (dialogResult) => {
            if (dialogResult.event) {
              var status;
              if (val == "Approve") status = "Approved";
              else status = "Rejected";
              var msg = status == "Approved" ? "approve" : "reject";
              if (confirm("Are you sure you want to " + msg + " the resignation?"))
              {
                this.updateOffboardingResgnStatus.ManagerResignationComments =
                  dialogResult.data;
                this.updateOffboardingResgnStatus.status = status;
                this.updateOffboardingResgnStatus.OffboardingID =
                  this.offboarding.ID;
                this.updateOffboardingResgnStatus.EmpCode = this.empCode;
                this.updateOffboardingResgnStatus.ExitID =
                  this.offboarding.ExitID;
                this.updateOffboardingResgnStatus.Designation = "Manager";
                this.updateOffboardingResgnStatus.IndicativeLWD =
                  this.offboarding.IndicativeLWD;
                this.updateOffboardingResgnStatus.LastWorkingDay =
                  !isNullOrUndefined(this.offboarding.LastWorkingDay)
                    ? new Date(
                        this.datePipe.transform(
                          this.offboarding.LastWorkingDay,
                          this.config.dateFormat()
                        )
                      )
                    : null;
                this.updateOffboardingResgnStatus.ModifiedBy =
                  this.LoginEmpCode;
                this.updateOffboardingResgnStatus.ResignationDate =
                  this.offboarding.ResignationDate;
                this.updateOffboardingResgnStatus.ReasonID =
                  this.offboarding.ReasonID;
                this.updateOffboardingResgnStatus.CC = this.offboarding.CC;
                this.updateOffboardingResgnStatus.ProjectManagers = this.offboarding.ProjectManagers;
                status == "Approved"
                  ? (this.updateOffboardingResgnStatus.IsManagerApprReject =
                      true)
                  : (this.updateOffboardingResgnStatus.IsManagerApprReject =
                      false);
                this.empsvc
                  .UpdateResignationStatus(this.updateOffboardingResgnStatus)
                  .subscribe(
                    (data: any) => {
                      this.toastr.success(
                        `Resignation ${status} Successfully.`
                      );
                      this.parentFun.emit();
                      if (status == "Approved")
                        this.router.navigate([
                          "Offboardinglist / tabIndex /" + 0 +"/ subIndex /"+1,
                        ]);
                      else
                        this.router.navigate([
                          "Offboardinglist / tabIndex /" + 0 + "/ subIndex /" + 2,
                        ]);
                      window.scrollTo(0, 0);

                      setTimeout(() => {
                        this.loader = false;
                      }, 1000);
                    },
                    (error) => {
                      this.error = error;
                      this.loader = false;
                    }
                  );
              }
              else {
                this.loader = false;
                setTimeout(() => {
                  this.loader = false;
                }, 1000);
              }
            } else {
              this.loader = false;
              setTimeout(() => {
                this.loader = false;
              }, 1000);
            }
          },
          (error) => {
            this.loader = false;
          }
        );
      } else if (val == "Quick Approve") {
        this.updateOffboardingResgnStatus.ManagerResignationComments = null;
        this.updateOffboardingResgnStatus.status = "Approved";
        this.updateOffboardingResgnStatus.OffboardingID = this.offboarding.ID;
        this.updateOffboardingResgnStatus.EmpCode = this.empCode;
        this.updateOffboardingResgnStatus.ExitID = this.offboarding.ExitID;
        this.updateOffboardingResgnStatus.Designation = "Manager";
        this.updateOffboardingResgnStatus.IndicativeLWD =
          this.offboarding.IndicativeLWD;
        this.updateOffboardingResgnStatus.LastWorkingDay = new Date(
          this.datePipe.transform(
            this.offboarding.LastWorkingDay,
            this.config.dateFormat()
          )
        );
        this.updateOffboardingResgnStatus.ModifiedBy = this.LoginEmpCode;
        this.updateOffboardingResgnStatus.ResignationDate =
          this.offboarding.ResignationDate;
        this.updateOffboardingResgnStatus.ReasonID = this.offboarding.ReasonID;
        this.updateOffboardingResgnStatus.IsManagerApprReject = true;
        this.updateOffboardingResgnStatus.CC = this.offboarding.CC;
        this.updateOffboardingResgnStatus.ProjectManagers = this.offboarding.ProjectManagers;
        this.empsvc
          .UpdateResignationStatus(this.updateOffboardingResgnStatus)
          .subscribe(
            (data: any) => {
              this.toastr.success("Resignation Approved Successfully.");
              this.router.navigate([
                "Offboardinglist/tabIndex/" +
                  Number(sessionStorage.getItem("tabIndex")) || 0,
              ]);
              this.parentFun.emit();
              window.scrollTo(0, 0);

              setTimeout(() => {
                this.loader = false;
              }, 1000);
            },
            (error) => {
              this.error = error;
              this.loader = false;
            }
          );
      } else {
        this.loader = false;
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      }
    } else {
      this.offboardingForm.markAllAsTouched();
      this.cdr.detectChanges();
    }
  }

  cancel() {
    this.loader = true;
    window.location.reload();
    this.loader = false;
  }

  getStatus(item) {
    if (item.finalStatus === "Rejected") {
      if (item.Designation === "manager") {
        item.finalStatus = "Rejected (Manager)";
      } else if (item.Designation === "HR") {
        item.finalStatus = "Rejected (HR)";
      }
    }

    if (item.finalStatus === "Revoked") {
      if (item.HRResignationComments) {
        item.finalStatus = "Revoked (HR)";
      } else if (item.ManagerResignationComments) {
        item.finalStatus = "Revoked (Manager)";
      } else {
        item.finalStatus = "Revoked (Employee)";
      }
    }
    return item.finalStatus;
  }
}

export class dropObj {
  DisplayName: string;
  Email: string;
}
